var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-row',{staticClass:"text-left"},[_c('b-col',[_c('h2',[_vm._v("Organizations")]),_c('h5',{staticClass:"text-secondary"},[_vm._v(_vm._s(_vm.globalData.activeUser.name))])])],1),_c('br'),_c('b-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('OrganizationList',{attrs:{"globalData":_vm.globalData}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }